import { __assign, __generator, __spreadArray } from "tslib";
import { all, call, put, select } from 'redux-saga/effects';
import groupBy from 'lodash/groupBy';
import { selectors, withOffset } from '../../Stream';
import { request } from '../../xhr';
import { MediaSourceType } from '../types';
import { fetchMoreGallectionsDone } from '../actions';
import { getGallectionStreamId, getGallectionType } from '../helpers';
import { getStreamInitAction } from './initGallectionStream';
import { ALL_FOLDER_ID, ALL_FOLDER_NAME } from '@wix/da-url';
import { normalizeGallections } from '../../redux/normalizr/helpers';
export function fakeResponse(_a) {
    var params = _a.params;
    if (process.env.NODE_ENV !== 'production') {
        var gallections_1;
        var putFeaturedFolderFirst = function (a, b) { return (a.name === 'Featured' ? -1 : 1); };
        if (params.type === MediaSourceType.GALLERY) {
            var _b = require('@wix/da-sample-data'), galleries = _b.galleries, galleriesFolderScraps = _b.galleriesFolderScraps; // eslint-disable-line global-require
            gallections_1 = galleries;
            gallections_1 = __spreadArray(__spreadArray([], gallections_1, true), [galleriesFolderScraps], false);
            gallections_1 = gallections_1.map(function (gallery, index) {
                // make every 5th gallery a subfolder of the second one (after Featured which can't have subfolders)
                return index % 5 === 2 // starting from 2 to leave Featured, Scraps folders alone
                    ? __assign(__assign({}, gallery), { parentId: gallections_1[1].folderId }) : gallery;
            });
            var fakeAllFolder = __assign(__assign({}, gallections_1[2]), { parentId: null, folderId: ALL_FOLDER_ID, name: ALL_FOLDER_NAME });
            var paidGallection = __assign(__assign({}, gallections_1[2]), { parentId: null, premiumFolderData: {
                    type: 'paid',
                    hasAccess: true,
                    pointsPrice: 800,
                    dollarPrice: 10,
                    numSubscribers: 3,
                } });
            var watchersGallection = __assign(__assign({}, gallections_1[3]), { parentId: null, premiumFolderData: {
                    type: 'watchers',
                    hasAccess: true,
                    pointsPrice: 800,
                    dollarPrice: 10,
                    numSubscribers: 3,
                } });
            gallections_1 = __spreadArray([
                fakeAllFolder,
                paidGallection,
                watchersGallection
            ], gallections_1.slice(4), true);
        }
        else if (params.type === MediaSourceType.STASH) {
            var stashGallections = require('@wix/da-sample-data').stashGallections; // eslint-disable-line global-require
            gallections_1 = stashGallections;
        }
        else {
            var collections = require('@wix/da-sample-data').collections; // eslint-disable-line global-require
            gallections_1 = collections.sort(putFeaturedFolderFirst);
        }
        if (window.doError) {
            return {
                error: 'invalid_request',
                error_description: 'Not logged in.',
                status: 'error',
            };
        }
        return {
            results: gallections_1,
            hasMore: true,
        };
    }
}
function fetch(url, params) {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, call(request, {
                    method: 'get',
                    url: url,
                    params: params,
                }, fakeResponse)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response];
        }
    });
}
function getStreamFetchSuccessAction(mediaSource, folderId, gallectionFolders) {
    var streamId = getGallectionStreamId(mediaSource, folderId);
    var _a = normalizeGallections(gallectionFolders), result = _a.result, entities = _a.entities;
    return withOffset.actions.fetchSuccess({
        streamId: streamId,
        hasMore: false,
        items: result,
        entities: entities,
    });
}
function handleGallectionStreamFetch(action) {
    var streamId, _a, offset, limit, mediaSource, params, response, results, foldersByParentId, nonZeroParentIds;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                streamId = action.streamId;
                return [4 /*yield*/, select(function (state) { return ({
                        offset: withOffset.selectors.getNextOffset(state, streamId),
                        limit: selectors.getItemsPerFetch(state, streamId),
                        mediaSource: selectors.getStreamParam(state, streamId, 'mediaSource'),
                    }); })];
            case 1:
                _a = _c.sent(), offset = _a.offset, limit = _a.limit, mediaSource = _a.mediaSource;
                if (!mediaSource) {
                    return [2 /*return*/];
                }
                params = {
                    offset: offset,
                    limit: limit,
                    type: (_b = getGallectionType(mediaSource)) !== null && _b !== void 0 ? _b : 'collection',
                    with_all_folder: mediaSource !== MediaSourceType.STASH,
                };
                return [4 /*yield*/, call(fetch, 'gallection/folders', params)];
            case 2:
                response = _c.sent();
                if (!!response) return [3 /*break*/, 4];
                return [4 /*yield*/, put(fetchMoreGallectionsDone(false, mediaSource))];
            case 3:
                _c.sent();
                return [2 /*return*/];
            case 4:
                results = response.results;
                if (!!results) return [3 /*break*/, 7];
                // TODO: request does not return error message atm
                return [4 /*yield*/, put(withOffset.actions.fetchFailure({
                        streamId: streamId,
                        errorMsg: 'Failed to fetch',
                    }))];
            case 5:
                // TODO: request does not return error message atm
                _c.sent();
                return [4 /*yield*/, put(fetchMoreGallectionsDone(false, mediaSource))];
            case 6:
                _c.sent();
                return [2 /*return*/];
            case 7:
                foldersByParentId = groupBy(results || [], 'parentId');
                nonZeroParentIds = Object.keys(foldersByParentId).filter(function (parentId) { return +parentId; });
                if (!nonZeroParentIds.length) return [3 /*break*/, 9];
                // if we have folders with subfolders, need to init streams for them
                return [4 /*yield*/, all(nonZeroParentIds.map(function (parentId) {
                        return put(getStreamInitAction(mediaSource, Number(parentId)));
                    }))];
            case 8:
                // if we have folders with subfolders, need to init streams for them
                _c.sent();
                _c.label = 9;
            case 9: return [4 /*yield*/, all(Object.keys(foldersByParentId).map(function (parentId) {
                    var folders = foldersByParentId[parentId];
                    return put(getStreamFetchSuccessAction(mediaSource, +parentId, folders));
                }))];
            case 10:
                _c.sent();
                return [4 /*yield*/, put(fetchMoreGallectionsDone(true, mediaSource))];
            case 11:
                _c.sent();
                return [2 /*return*/];
        }
    });
}
export default handleGallectionStreamFetch;
//# sourceMappingURL=gallectionStreamFetch.js.map